import _ from 'lodash'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import i18n from 'scoreboard/components/i18n'

var ImportMenu = BootslideMenu.extend({

	className: 'import-menu',

	initialize: function (opt) {
		BootslideMenu.prototype.initialize.apply(this, arguments)
		this.importOptions = opt.importOptions || []
		this.width = _.get(opt, 'width', 190)
		this.allowDynamicWidth = true
	},

	menu: function () {
		var options = []
		for (var i = 0; i < this.importOptions.length; i++) {
			var optionConstructorFn = this.importOptions[i]
			options.push({
				contentView: optionConstructorFn
			})
		}

		return {
			label: i18n.get('admin.import'),
			target: options,
			width: this.width
		}
	}
})

export default ImportMenu

ImportMenu.__filename__ = 'components/import-menu.js'
